import { Pagination } from "react-bootstrap";
import TableSelect from "../../../../../../components/TableSelect/TableSelect";
import "./PaginationControls.css";

interface PaginationControlsProps {
    currentPage: number;
    totalPages: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    itemsPerPage: number;
    setItemsPerPage: React.Dispatch<React.SetStateAction<number>>;
    startResult: number;
    endResult: number;
    totalItems: number;
}

const PaginationControls = ({
    currentPage,
    totalPages,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    startResult,
    endResult,
    totalItems,
}: PaginationControlsProps) => {
    return (
        <div className="pagination-wrapper">
            <div className="pagination-info">
                Exibindo {startResult} a {endResult} de {totalItems} registros
            </div>

            <div className="pagination-layout">
                <div className="items-per-page">
                    <span>Itens por página</span>
                    <TableSelect
                        ariaLabel="Itens por página"
                        value={itemsPerPage}
                        options={[
                            { value: 10, label: "10" },
                            { value: 20, label: "20" },
                            { value: 30, label: "30" },
                        ]}
                        onChange={(value) => {
                            setItemsPerPage(value);
                            setCurrentPage(1);
                        }}
                    />
                </div>

                <Pagination className="custom-pagination">
                    <Pagination.Prev
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    />

                    {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                            key={index + 1}
                            className={index + 1 === currentPage ? "pagination-active" : ""}
                            onClick={() => setCurrentPage(index + 1)}
                        >
                            {index + 1}
                        </Pagination.Item>
                    ))}

                    <Pagination.Next
                        onClick={() =>
                            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                        }
                        disabled={currentPage === totalPages}
                    />
                </Pagination>
            </div>
        </div>
    );
};

export default PaginationControls;